import Link from 'next/link'
import Router from 'next/router'
import {
  claimProduct_itemModule_userGetArtwork,
  RareFlag,
  SeriesType,
} from '~/graphqls/types'
import { MyBtn } from '../ui/MyBtn'
import { MyImage } from '../ui/MyImage'
import { MyModal } from '../ui/MyModal'
import { MyRare } from '../ui/MyRare'

export const GetProductResultModal: React.FC<{
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  data: claimProduct_itemModule_userGetArtwork | undefined
}> = ({ visible, data }) => {
  const isMysteryBox = data?.collection?.type === SeriesType.BLIND_BOX

  return (
    <MyModal
      visible={visible}
      closable={false}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      bodyStyle={{
        padding: 16,
        textAlign: 'center',
      }}
      width={270}
      footer={null}
    >
      <div className="relative">
        {isMysteryBox && (
          <img
            className="absolute w-full top-4 left-0 right-0 m-auto z-10"
            src="/images/mystery-box/cheer.png"
            alt="cheer"
          />
        )}

        <div className="text-lg neutral-200 mb-2 font-semibold">恭喜获得</div>
        <div className="text-sm neutral-200 mb-2">
          <MyRare className="-mt-1" rare={data?.rareFlag as RareFlag} />{' '}
          {data?.name}
        </div>
        <MyImage
          className="w-[238px] h-[238px] object-cover rounded-2xl mb-4"
          lazy={false}
          tag="v800"
          src={data?.artworkUrl}
        />
        <div className="flex justify-between">
          <MyBtn
            style={{ width: 112 }}
            onClick={() => {
              location.reload()
            }}
          >
            取消
          </MyBtn>
          <MyBtn style={{ width: 112 }} type="primary">
            <a
              onClick={e => {
                location.href = `/product/${data?.id}`
              }}
            >
              去查看
            </a>
          </MyBtn>
        </div>
      </div>
    </MyModal>
  )
}
